// 004 (FR-041): a parent with saved addresses picks one (the default preselected) or adds a new
// one. Choosing an existing address sends nothing for it.
import { StyleSheet, View } from "react-native";

import { makeStyles } from "@/theme/makeStyles";
import { PressableTarget } from "@/ui/PressableTarget";
import { Text } from "@/ui/Text";

import { PROFILE_COPY } from "../copy";
import type { AddressVM } from "../viewModels";

export const NEW_ADDRESS = "new";

const useStyles = makeStyles((t) =>
  StyleSheet.create({
    list: { gap: t.space.sm },
    option: {
      alignItems: "flex-start",
      padding: t.space.md,
      borderRadius: t.radius.panel,
      borderWidth: t.borderWidth.input,
      borderColor: t.color.border,
      backgroundColor: t.color.surface,
      gap: t.space.xxs,
    },
    on: { borderColor: t.color.primary, backgroundColor: t.color.primarySoft },
  }),
);

export function AddressChooser({
  items,
  value,
  onChange,
}: {
  items: readonly AddressVM[];
  value: string;
  onChange: (id: string) => void;
}) {
  const styles = useStyles();
  const options = [
    ...items.map((a) => ({ id: a.id, title: a.title, line: a.oneLine })),
    { id: NEW_ADDRESS, title: PROFILE_COPY.newAddress, line: "" },
  ];
  return (
    <View
      style={styles.list}
      role="radiogroup"
      aria-label={PROFILE_COPY.chooseAddress}
    >
      <Text weight="semiBold">{PROFILE_COPY.chooseAddress}</Text>
      {options.map((o) => {
        const on = o.id === value;
        return (
          <PressableTarget
            key={o.id}
            accessibilityRole="radio"
            accessibilityLabel={o.line ? `${o.title}: ${o.line}` : o.title}
            accessibilityState={{ checked: on }}
            aria-checked={on}
            onPress={() => onChange(o.id)}
            style={on ? [styles.option, styles.on] : styles.option}
          >
            <Text weight="semiBold">{o.title}</Text>
            {o.line ? <Text tone="muted">{o.line}</Text> : null}
          </PressableTarget>
        );
      })}
    </View>
  );
}
